import { ComponentOverlay } from "csi/components/index";
import { StatefulFormField } from "csi/middleware/form/index";
import React, { ReactElement } from "react";
import { IFormField } from "src/c8-platform/type/form";
import css from "./SelectableFormFieldOverlay.module.css";

export const renderFieldOverlay = (field: IFormField, overlay?: ReactElement): ReactElement => (
	<ComponentOverlay
		className={css.componentOverlay}
		isOverlayBehindChildren
		overlay={overlay}
	>
		<StatefulFormField
			field={field}
			nodeType={field.reflectionAttributeOwner}
		/>
	</ComponentOverlay>
);
